// src/forms/psychologicalAssessmentForm.js
import * as Yup from 'yup';

export const initialValues = {
    location: null,
    student: null,
    employee: null,
    diagnosis: null,
    session: {
        date: '',
        startTime: '',
        endTime: ''
    },
    assessmentType: null,
    qualified: null,
    activity: null,
    notes: ''
};

export const validationSchema = Yup.object({
    location: Yup.object().required('Please select a location').typeError('Please select a location'),
    student: Yup.object().required('Please select a patient').typeError('Please select a patient'),
    employee: Yup.object().required('Please select an employee').typeError('Please select an employee'),
    diagnosis: Yup.object().required('Please select a diagnosis').typeError('Please select a diagnosis'),
    session: Yup.object({
        date: Yup.date().required('Please select a date').nullable().typeError('Please Enter a Valid Date'),
        startTime: Yup.date().required('Please enter a start time').typeError('Please enter a valid start time'),
        endTime: Yup.date()
            .required('Please enter an end time')
            .typeError('Please enter a valid end time')
            .test('is-greater', 'End time cannot be earlier than start time', function (value) {
                const { startTime } = this.parent;
                if (!startTime || !value) return true; // skip if either is missing

                return value >= startTime;
            })
    }),
    assessmentType: Yup.object().nullable().required('Please select an assessment type'),
    qualified: Yup.string().required('Please select an option').typeError('Please select an option'),
    activity: Yup.object().nullable().required('Please select an activity'),
    notes: Yup.string().nullable()
});
